<template>
  <div class="news-item">
    <div
      :class="['news-item__image-container', { 'news-item__image-container--no-image': !image }]"
    >
      <router-link class="news-item" :to="`news/${$i18n.locale}/${link}`">
        <div :style="{ background: `url(${image})` }" v-if="image">
          <div class="news-item__image-container__placeholder" />
        </div>
        <h2 v-if="!image" class="news-item__image-container__title-featured">{{ title }}</h2>
      </router-link>
    </div>
    <div class="news-item__infos">
      <router-link :to="`news/${$i18n.locale}/${link}`">
        <h2 v-if="image">{{ title }}</h2>
        <p>{{ description }}</p>
        <p class="news-item__infos__btn">{{ $t("generals.readmore") }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss">
.news {
  &__cell {
    &:hover {
      transition: opacity 0.3s ease-in-out;
      .news-item__image-container__placeholder {
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
      }

      .news-item__image-container__title-featured {
        color: rgba(0, 0, 0, 0.4);
        transition: color 0.3s ease-in-out;
      }
    }
  }
}
.news-item {
  display: flex;
  width: 100%;

  &__image-container {
    max-width: 600px;
    width: 100%;

    div {
      width: 100%;
      height: 100%;
      background-size: cover !important;
      min-height: 380px;
      background-position: center center !important;
      position: relative;
    }

    &__placeholder {
      background-color: rgba(0, 0, 0, 0.7);
      position: relative;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    }

    h2 {
      font-size: 55px;
      font-weight: 300;
      line-height: 55px;
      color: black;
    }

    &--no-image {
      max-width: 360px;
    }

    &__title-featured {
      transition: color 0.3s ease-in-out;
      color: black;
      text-transform: uppercase;
    }
  }

  &__infos {
    max-width: 260px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-left: 25px;
    color: black;

    h2 {
      font-size: 50px;
      font-weight: 300;
      line-height: 55px;
      text-transform: uppercase;
    }

    p {
      font-size: 20px;
      font-weight: 300;
    }

    a {
      text-align: left;
      display: block;
      position: relative;
      width: 100%;
      text-decoration: none;
      transition: color 0.3s ease-out;
      color: black;
      font-size: 18px;

      &:hover {
        color: rgba(0, 0, 0, 0.7);
        transition: color 0.3s ease-out;
      }
    }

    &__btn {
      display: block;
      margin-top: 10px;
      font-family: $tertiary;
      text-transform: uppercase;
    }
  }
}

@media (max-width: 1000px) {
  .news-item {
    display: flex;
    width: 100%;

    &__image-container {
      max-width: 400px;

      h2 {
        font-size: 40px;
        font-weight: 300;
        line-height: 55px;
      }

      div {
        min-height: 33vw;
      }

      &--no-image {
        max-width: 360px;
      }
    }

    &__infos {
      h2 {
        font-size: 40px;
        font-weight: 300;
        line-height: 55px;
      }

      p {
        font-size: 15px;
      }

      a {
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 745px) {
  .news-item {
    &__image-container {
      max-width: 400px;

      h2 {
        font-size: 30px;
        font-weight: 300;
        line-height: 45px;
      }

      &--no-image {
        max-width: 360px;
      }
    }

    &__infos {
      h2 {
        font-size: 30px;
        font-weight: 300;
        line-height: 45px;
      }

      p {
        font-size: 15px;
      }

      a {
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 745px) {
  .news-item {
    &__image-container {
      max-width: 400px;

      h2 {
        font-size: 25px;
        font-weight: 300;
        line-height: 35px;
      }

      &--no-image {
        max-width: 360px;
      }
    }

    &__infos {
      h2 {
        font-size: 25px;
        font-weight: 300;
        line-height: 35px;
      }

      p {
        font-size: 14px;
      }

      a {
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 360px) {
  .news-item {
    &__image-container {
      div {
        min-height: 230px;
      }

      h2 {
        font-size: 25px;
        font-weight: 300;
        line-height: 35px;
      }

      &--no-image {
        max-width: 360px;
      }
    }

    &__infos {
      align-items: start;
      margin-right: 15px;

      h2 {
        font-size: 25px;
        font-weight: 300;
        line-height: 35px;
      }

      p {
        font-size: 14px;
      }

      a {
        font-size: 16px;
      }
    }
  }
}
</style>
